
import OabatTextFieldSearchIcon from "@/components/base/design/OabatTextFieldSearchIcon"

import { mapGetters } from "vuex"
import { mdiChevronLeft } from "@mdi/js"

export default {
    name: "Search",
    components: {
        OabatTextFieldSearchIcon,
    },
    props: {
        transparent: {
            type: Boolean,
            default: false,
        },
        hide: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mdiChevronLeft,
        }
    },
    computed: {
        ...mapGetters("search", {
            isSearchActive: "active",
            searchLocation: "location",
            selectedCategory: "selectedCategory",
            getRoute: "route",
            filter: "filter",
            searchModal: "searchModal",
        }),
        backButtonVisible() {
            return (
                this.selectedCategory !== undefined &&
                this.$route.name !== "Home" &&
                this.$route.name !== "GeoCityOverview"
            )
        },
        menuVisible() {
            return (
                !this.$breakpoint.lgAndUp &&
                (this.selectedCategory == undefined ||
                    this.selectedCategory == "Alles")
            )
        },
    },
    methods: {
        toogleDialog() {
            this.$store.commit("search/SET_SEARCH_MODAL", !this.searchModal)
        },
        goBack() {
            let route = { name: "index" }
            if (
                this.$route.name === "livestream-livestream-suche" &&
                !this.isSearchActive
            ) {
                this.$router.push("/")
                return
            }
            if (this.$route.name === "betriebe-slug") {
                route = this.getRoute({
                    category: this.selectedCategory,
                })
            } else if (
                this.selectedCategory &&
                this.selectedCategory !== "Alles"
            ) {
                const { latitude, longitude } = this.filter
                route = this.getRoute({
                    category: "Alles",
                    filters: { latitude, longitude },
                })
            } else if (this.searchLocation) {
                route = { name: "index" }
            }
            this.$router.replace(route)
        },
    },
}
